<template>
    <form @submit.prevent="saveNote" class="order-note-form d-flex" v-if="$store.state.cart">
        <label class="placeholder-label"  v-show="!showSaveBtn && orderNote.length < 1">
            <span class="fa fa-pencil-square-o" aria-hidden="true"></span>
            Add an order note...
        </label>
        <textarea @input="updateNote" v-bind:value="$store.state.cart.orderNote" ref="note" class="order-note-input d-none d-md-flex" :class="{ 'order-note-input--active': showSaveBtn }" maxlength="2000" @blur="saveNote()" @focus="showSaveBtn = true" v-on:input="sanitizeOrderNoteInput"></textarea>

        <input type="text" @input="updateNote" v-bind:value="$store.state.cart.orderNote" ref="note" class="order-note-input d-flex d-md-none" :class="{ 'order-note-input--active': showSaveBtn }" maxlength="2000" @blur="saveNote()" @focus="showSaveBtn = true" v-on:input="sanitizeOrderNoteInput">
        <button class="btn btn-primary inline-btn" type="submit" v-show="showSaveBtn">
            <span class="d-none d-md-block">Save Now</span>
            <span class="d-block d-md-none">Save</span>
        </button>
    </form>
</template>
<script>
export default {
  name: 'CartOrderNote',
  data () {
    return {
      showSaveBtn: false
    }
  },
  computed: {
    orderNote: {
      get () {
        return this.$store.state.cart.orderNote
      },
      set (value) {
        this.$store.commit('cart/EDIT_ORDER_NOTE', value)
      }
    }
  },
  methods: {
    saveNote () {
      this.sanitizeOrderNoteInput();
      this.$store.dispatch('cart/POST_ORDER_NOTE', this.orderNote)
      this.showSaveBtn = false
    },
    updateNote (e) {
      this.orderNote = e.target.value
    },
    sanitizeOrderNoteInput() {
      //Remove non-ASCII characters from the order note.
      this.orderNote = this.orderNote.replace(/[^\x00-\x7F]/g, "");
    }
  }
}
</script>
<style lang="scss" scoped>
    @import '../../assets/lib';
    // Order note CSS section

    .order-note-form {
        position: relative;
        margin: 4px 0 11px;

        button {
            min-width: 63px;
            position: absolute;
            right: 0;
            height: 100%;
        }
    }

    .order-note-input {
        height: 36px;
        width: 100%;
        resize: none;
        box-sizing: border-box;
        padding-top: 7px;
        outline: none;

        // .order-note-input--active
        &--active {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            padding-right: 70px;
        }

        &:focus {
            border: 1px solid #8B8B8B;
        }
    }

    .placeholder-label {
        color: $input-placeholder-color;
        font-family: $font-standard-text;
        font-size: 14px;
        line-height: 19px;
        position: absolute;
        top: 8px;
        left: 8px;
        opacity: .5;
        pointer-events: none;
    }

    @media screen and (min-width: $breakpoint-tablet){
        .order-note-form {
            position: relative;
            margin: 32px 0 8px;
            button {
                width: 100%;
                max-height: 36px;
                position: absolute;
                bottom: 0;
            }
        }
        .order-note-input {
            resize: none;
            padding-right: 8px;
            height: 68px;
            &--active {
                height: 80px;
                box-shadow: 0 0 4px rgba(0, 0, 0, 0.5);
                margin-bottom: 32px;
            }
        }
    }
    // End of order note CSS section
</style>
